import CTA from "../CTA/CTA";
import s from "./Form.module.scss";


const Form = () => {

    return (
        <>
            <div className={s.form} data-rgive-src="https://donner.avh.asso.fr/noel/"></div>

            <CTA 
                place="headerForm"
                variant="orange"
                text="Je fais un don"
                href="https://donner.avh.asso.fr/noel/?from=W26FALP&utm_source=lp&utm_medium=organic&utm_campaign=FA26"
            />
        </>
    )
}

export default Form;


